import { FormStateData, TrackLeadRequestBody } from "state/form/types"
import { PreOwnedFormStateData } from "state/preownedForm/types"

export type StepValidation = {
  [key: string]: (keyof FormStateData)[]
}

interface GetTrackLeadPayloadArgs {
  step: number
  payload: FormStateData | PreOwnedFormStateData
  config: StepValidation
  product: string
  carType: string
  bank?: string
  path?: string
  leadRecordType?: string
  journeyCompleted?: boolean
}

export const getTrackLeadPayload = ({
  step,
  payload,
  config,
  product,
  carType,
  bank,
  path,
  leadRecordType,
  journeyCompleted
}: GetTrackLeadPayloadArgs): TrackLeadRequestBody => {
  const stepFields = Object.values(config)[step - 1]
  if (!stepFields) {
    return {}
  }

  const trackLeadPayload = stepFields.reduce((acc, field) => {
    return {
      ...acc,
      [field]: payload[field]
    }
  }, {})

  return {
    ...trackLeadPayload,
    path,
    leadRecordType,
    product,
    newCar: carType === "new",
    journeyCompleted,
    bank
  }
}
